import React from 'react';
import { ILxsCreateOrderResources } from '../lxs-create-order.props.autogenerated';
import LoadingButton from '../../../components/loading-button';
interface IDisclaimerProps {
    resources: ILxsCreateOrderResources;
    placeOrder: () => void;
}

const disclaimer = ({ resources, placeOrder }: IDisclaimerProps) => {
    const [accepted, setAccepted] = React.useState<boolean>(false);
    return (
        <div className='lxs-create-order__disclaimer'>
            <div className='msc-section-box col-lg-4'>
                <p dangerouslySetInnerHTML={{ __html: resources.createOrderOverviewDisclaimerText }} />
                <div className='lxs-create-order__disclaimer-container'>
                    <div className='msc-form__check'>
                        <label htmlFor='accept'>
                            <input type='checkbox' id='accept' name='accept' checked={accepted} onChange={() => setAccepted(!accepted)} />
                            {resources.createOrderOverviewDisclaimerAcceptLabel}
                        </label>
                    </div>
                    <LoadingButton
                        label={resources.createOrderOverviewDisclaimerPlaceOrderLabel}
                        disabled={!accepted}
                        onClick={() => placeOrder()}
                    />
                </div>
            </div>
        </div>
    );
};

export default disclaimer;
